<template>
    <div class="product-card-302 " :key='product.id'>

      <div class="col product-302-card">
        <div class="row align-items-center justify-content-center">

          <div class="col-4 product-card-302-image">
            <img data-toggle="modal" @click="setCurrentOpenModal(product)" :data-target="`#modal-${product.id}`"
                 :src="product.thumbnail"
                 :alt="product.name"
                 class="mt-1 card-image ">
          </div>

          <div class="col-8 product-card-302-content">
           <div class="mr-2">
             <h6 data-toggle="modal" @click="setCurrentOpenModal(product)" :data-target="`#modal-${product.id}`"
                 class="my-2">{{ product.name }}</h6>
             <p class="product302-description-font-size" v-html="product.description"></p>
           </div>
          </div>
        </div>

        <div class="row align-items-center justify-content-center mt-1  pb-2">
          <div class="text-center col-5 product-card-302-price">
            <m-product-price100 data-toggle="modal" @click="setCurrentOpenModal(product)"
                                :data-target="`#modal-${product.id}`" class="text-white "
                                :product="product"/>
          </div>

          <div class="col-7 product-card-302-quantity-manager">
            <m-product-card-quantity-manager1 class="text-center" :product="product"/>
          </div>
        </div>

      </div>


      <m-product-modal302 v-if="currentOpenModal === product.id" :product="product"/>

    </div>
</template>


<script>
import {defineComponent} from 'vue'
import mProductModal302 from "./ProductModal302.vue";
import mProductCardQuantityManager1 from "../../QuantityManager/Card/ProductCardQuantityManager1.vue";
import mProductPrice100 from "../../ProductPrice100.vue";

export default defineComponent({
  name: "ProductCard302",
  components: {mProductPrice100, mProductCardQuantityManager1, mProductModal302},
  props: {
    product: {}
  },
  data() {
    return {
      currentOpenModal: null
    }
  },
  methods: {
    setCurrentOpenModal(product) {
      this.currentOpenModal = product.id
    },
  }
})
</script>


<style scoped>
.products-302 :deep(.product-card-price) {
  font-size: 10px !important;
}

.products-302 :deep(.product-price) {
  font-size: 12px !important;
}


.product-302-card img {
  margin-top: 15px !important;
}

.product302-description-font-size * {
  font-size: 11px !important;
}

.card-image {
  width: 112px !important;
  height: 112px;
  object-fit: cover;
}


.product-302-card {
  background: var(--secondary) ;
  color: var(--dark);
  border-radius: 5px;
}

</style>